import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '@/components/Button';
import { ProfileService } from '@/services';
import { ReactComponent as EditIcon } from '@/assets/images/icons/edit.svg';
import ModalInformationComponent from './ModalBillingInfomation';

import './index.scss';

function InformationComponent() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const showDrawer = () => {
    setOpen(true);
  };

  const [defaultBillingData, setDefaultBillingData] = useState({
    defaultBillingFirstName: '',
    defaultBillingLastName: '',
    defaultBillingEmail: '',
    defaultBillingPhone: '',
    defaultBillingTaxNumber: '',
    defaultBillingCountry: '',
    defaultBillingProvince: '',
    defaultBillingDistrict: '',
    defaultBillingSubDistrict: '',
    defaultBillingZipcode: '',
    defaultBillingAddress: '',
  });

  const fetchDefaultBillingInfo = async () => {
    const resp = await ProfileService.getBillingInfo();

    if (resp.success && resp.data) {
      const { data: billing } = resp;
      const {
        defaultBillingCountry: _country,
        defaultBillingProvince: _province,
        defaultBillingDistrict: _district,
        defaultBillingWard: _ward,
      } = billing;
      setDefaultBillingData({
        defaultBillingFirstName: billing?.defaultBillingFirstName,
        defaultBillingLastName: billing?.defaultBillingLastName,
        defaultBillingEmail: billing?.defaultBillingEmail,
        defaultBillingPhone: billing?.defaultBillingPhone,
        defaultBillingTaxNumber: billing?.defaultBillingTaxNumber,
        defaultBillingCountry: {
          label: _country?.name,
          value: _country?.id,
        },
        defaultBillingProvince: {
          label: _province?.name,
          value: _province?.id,
        },
        defaultBillingDistrict: {
          label: _district?.name,
          value: _district?.id,
        },
        defaultBillingSubDistrict: {
          label: _ward?.name,
          value: _ward?.id,
        },
        defaultBillingZipcode: billing?.defaultBillingZipcode,
        defaultBillingAddress: billing?.defaultBillingAddress,
      });
    }
  };

  const onClose = () => {
    setOpen(false);
    fetchDefaultBillingInfo();
  };

  useEffect(() => {
    fetchDefaultBillingInfo();
  }, []);

  return (
    <div className="billinginfo-page">
      <div className="profile-content__info">
        <p className="profile-items">
          <strong>{t('profile_page.account.first_name')}</strong>{' '}
          <span>{defaultBillingData?.defaultBillingFirstName}</span>
        </p>
        <p className="profile-items">
          <strong>{t('profile_page.account.last_name')}</strong>{' '}
          <span>{defaultBillingData?.defaultBillingLastName}</span>
        </p>
        <p className="profile-items">
          <strong>{t('common.email')}</strong>{' '}
          <span>{defaultBillingData?.defaultBillingEmail}</span>
        </p>
        <p className="profile-items">
          <strong>{t('sign_up.form.fields.phone_number')}</strong>{' '}
          <span>
            {defaultBillingData?.defaultBillingPhone
              ? `+${defaultBillingData?.defaultBillingPhone}`
              : ''}
          </span>
        </p>
        <p className="profile-items">
          <strong>{t('customer_info.form.fields.tax_number')}</strong>{' '}
          <span>{defaultBillingData?.defaultBillingTaxNumber}</span>
        </p>
        <p className="profile-items">
          <strong style={{ width: '20%' }}>
            {t('customer_info.form.fields.address')}
          </strong>{' '}
          <span>{defaultBillingData?.defaultBillingAddress}</span>
        </p>
      </div>
      <ButtonComponent
        onClick={showDrawer}
        icon={<EditIcon />}
        className="btn-edit"
      >
        {t('button.edit')}
      </ButtonComponent>
      <ModalInformationComponent
        open={open}
        onClose={onClose}
        onFinish={ProfileService?.updateBillingInfomation}
        formData={defaultBillingData}
      />
    </div>
  );
}

export default InformationComponent;
